<template>
  <div class="userinfo cursor-pointer">
    <el-popover
      placement="bottom"
      trigger="click"
      popper-class="home_userinfo_popper-class"
      @show="showPopver"
    >
      <div class="userinfo__reference flex items-center" slot="reference">
        <!-- 头像 -->
        <div class="el-image userinfo__avatar flex">
          <img
            class="userinfo__avatar flex"
            v-if="userInfo.avatarUrl"
            :src="userInfo.avatarUrl"
            :alt="userInfo.name"
          />
          <div class="image-slot flex justify-center items-center" v-else>
            {{ avatarLabel }}
          </div>
        </div>
        <!-- 用户名 -->
        <span class="userinfo__reference__account">{{ userInfo.name }}</span>
        <!-- 当前等级 -->
        <div class="userinfo__current__leave">
          <img src="../../../assets/images/header/current_leave.png" />
          <span>{{
            userInfo.levelName === '17' ? '无' : userInfo.levelName
          }}</span>
        </div>
      </div>
      <!-- 弹窗内容 -->
      <div class="userinfo__popper flex flex-col">
        <!-- 个人信息 -->
        <div class="userinfo__popper__item flex items-center">
          <div class="personal flex items-center" @click="handlerClickPersonal">
            <div class="personal__icon">
              <img src="@/render/assets/images/header/personal.png" />
            </div>
            <div class="personal__text">个人信息</div>
          </div>
        </div>
        <!-- 我的考级 -->
        <div class="userinfo__popper__item flex items-center">
          <div class="order flex items-center" @click="handlerClickOrder">
            <div class="order__icon">
              <img src="@/render/assets/images/header/order.png" />
            </div>
            <div class="order__text">我的考级</div>
          </div>
        </div>
        <!-- 退出登录 -->
        <div class="userinfo__popper__item flex items-center">
          <div class="logout flex items-center" @click="logout">
            <div class="logout__icon">
              <img src="@/render/assets/images/header/exit.png" />
            </div>
            <div class="logout__text">退出登录</div>
          </div>
        </div>
        <!-- 账号截止日期
        <div class="userinfo__popper__item effective flex items-center">
          账号有效截止期<br/>{{endTime}}
        </div> -->
      </div>
    </el-popover>
  </div>
</template>

<script>
import _ from 'lodash'
import store from 'store'
import { authAPI } from '@/apis'
import { USER_INFO, UPDATE_USER_INFO } from '@/config/const'
import { dateFormat, clearLoginStatus } from '@/render/utils'

export default {
  name: 'UserInfo',
  props: {},
  data() {
    return {
      userInfo: {
        avatarUrl: '',
        name: '',
      },
      score: 0,
    }
  },
  components: {},
  computed: {
    avatarLabel() {
      const account = _.get(this, 'userInfo.name', 'C')
      return account.slice(0, 1)
    },
    endTime() {
      return this.userInfo.endTime
        ? dateFormat('YYYY-mm-dd HH:MM:SS', new Date(this.userInfo.endTime))
        : ''
    },
  },
  watch: {
    userInfo: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          const {
            userScoreFast,
            userScoreMiddle,
            userScoreUltraFast,
            scoreAi,
          } = newVal
          const arr = [
            userScoreFast,
            userScoreMiddle,
            userScoreUltraFast,
            scoreAi,
          ]
          let total = arr.reduce((before, next) => before + next)
          this.score = isNaN(total / arr.length) ? 0 : total / arr.length
        }
      },
      deep: true,
    },
  },
  created() {},
  async mounted() {
    this.userInfo = store.get(USER_INFO)
    this.$bus.on(UPDATE_USER_INFO, userInfo => {
      this.userInfo = userInfo
    })
  },
  methods: {
    async logout() {
      const result = await authAPI.postLogout()
      if (result.code === 0) {
        clearLoginStatus()
        if (this.userInfo.userType === '0') {
          this.$router.push('/login')
        } else {
          location.href = 'http://ixiaqi.com'
        }
      } else {
        this.$message.error('退出登录失败')
      }
    },
    handlerClickPersonal() {
      this.$router.push('/personal-info')
    },
    handlerClickOrder() {
      this.$router.push('/personal-order')
    },
    // 气泡显示弹窗
    showPopver() {},
  },
}
</script>

<style lang="scss" scoped>
.userinfo {
  color: var(--white-color);
  &__avatar {
    display: block;
    width: val(60);
    height: val(60);
    border: val(2) solid var(--hite-color);
    border-radius: 50%;
    background-color: var(--white-color);
  }
  &__reference {
    min-height: 100%;

    &__account {
      font-size: val(24);
      margin-left: val(20);
      font-weight: 500;
      color: var(--white-color);
    }
    ::v-deep {
      .image-slot {
        width: 100%;
        height: 100%;
        font-size: val(24);
        color: var(--black-color-3);
      }
    }
  }
  &__current {
    &__leave {
      position: relative;
      width: val(124);
      margin-left: val(40);
      span {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: val(24);
        color: #f5e08a;
      }
    }
  }
  &__popper {
    &__item {
      width: 100%;
    }
    .logout,
    .personal,
    .order {
      cursor: pointer;
      width: 100%;
      &__icon {
        width: val(17);
        margin-right: val(10);
      }
      &__text {
        font-size: val(18);
        line-height: 1em;
        color: #ff9100;
      }
    }
    .personal,
    .order {
      padding-bottom: val(15);
      margin-bottom: val(15);
      border-bottom: 1px solid #3e2c00;
    }
    .effective {
      border-top: 1px solid var(--boder-normal-color);
      padding: val(9) val(2) 0;
      font-size: val(16);
      line-height: val(24);
      color: var(--fonts-normal-color);
    }
  }
}
</style>
